module.exports = __webpack_public_path__ + "media/bootstrap-icons/shop-07c12059.svg";